import React, { useState } from "react";
import { Container, Row, Col, Button, Dropdown } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import AddNoteModal from "../../modals/notes/AddNoteModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb,  } from 'react-bootstrap';


const NotesHeader = () => {
  const [show, setShow] = useState(false);

  return (
    <Container fluid className="page-wrapper">
      <Row className="align-items-center justify-content-between mb-3">
        
        {/* LEFT SIDE */}
   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Notes</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                     Application
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Notes</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT SIDE */}
        <Col md={6} className="text-md-end mt-3 mt-md-0">
          
          <Dropdown className="d-inline me-2">
            <Dropdown.Toggle className="btn-white">
              <FiDownload className="me-2" />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button className="btn-orange" onClick={() => setShow(true)}>
            <FaPlus className="me-2" />
            Add Notes
          </Button>
        </Col>
      </Row>

      {/* MODAL */}
      <AddNoteModal show={show} handleClose={() => setShow(false)} />
          <style>
               {
                    `




/* BREADCRUMB */
.breadcrumb-custom {
  color: #6c757d;
  font-size: 14px;
}

.breadcrumb-custom .active {
  color: #000;
  font-weight: 500;
}

/* BUTTONS */
.btn-white {
  background: #fff;
  border: 1px solid #ddd;
  color: #000;
}

.btn-orange {
  background-color: #ff6a00;
  border: none;
}

.btn-orange:hover {
  background-color: #e65c00;
}

/* TAG BOX */
.tag-box {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  background: #f1f1f1;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.tag-box input {
  border: none;
  outline: none;
  flex: 1;
}

/* EDITOR */
.editor-toolbar {
  border: 1px solid #ddd;
  border-bottom: none;
  padding: 5px;
  display: flex;
  gap: 8px;
}

.editor-toolbar button {
  border: none;
  background: transparent;
}

textarea.form-control {
  border-radius: 0;
}

/* MODAL FIX */
.modal-content {
  border-radius: 10px;
}`
               }
          </style>
    </Container>
  );
};

export default NotesHeader;